import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { createTeam } from "store/teamSlice";
import { useHistory } from "react-router-dom";


export default function TeamCreate({ color }) {
const dispatch = useDispatch();
const history = useHistory();


const [fullName, setFullName] = useState("");
const [designation, setDesignation] = useState("");
const [profilePicture, setProfilePicture] = useState(null);


const handleSubmit = (e) => {
e.preventDefault();


const formData = new FormData();
formData.append("full_name", fullName);
formData.append("designation", designation);
if (profilePicture) formData.append("profile_picture", profilePicture);


dispatch(createTeam(formData)).then(() => {
history.push("/admin/team");
});
};

return (
<div className={"relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded " + (color === "light" ? "bg-white" : "bg-lightBlue-900 text-white")}>
<div className="max-w-4xl mx-auto p-6 bg-white shadow rounded">
<h2 className="text-xl font-semibold mb-4">Create Team Member</h2>


<form onSubmit={handleSubmit} className="space-y-4">
<div>
<label className="block text-sm font-medium mb-1">Full Name</label>
<input type="text" className="w-full border px-3 py-2 rounded" value={fullName} onChange={(e) => setFullName(e.target.value)} required />
</div>


<div>
<label className="block text-sm font-medium mb-1">Designation</label>
<input type="text" className="w-full border px-3 py-2 rounded" value={designation} onChange={(e) => setDesignation(e.target.value)} required />
</div>
<div>
<label className="block text-sm font-medium mb-1">Profile Picture</label>
<input type="file" onChange={(e) => setProfilePicture(e.target.files[0])} />
</div>


<div className="flex space-x-2">
<button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded">Create</button>
<button type="button" onClick={() => history.push("/admin/team")} className="bg-gray-300 px-4 py-2 rounded">Cancel</button>
</div>
</form>
</div>
</div>
);
}

TeamCreate.defaultProps = { color: "light" };
TeamCreate.propTypes = { color: PropTypes.oneOf(["light", "dark"]) };